export default __webpack_public_path__ + "static/media/A65.8f49df79.png";